<template>
  <form-field
    :id="id"
    :title="title"
    :class="className"
    :error-message="errorMessage"
    :show-label="showLabel"
    :mandatory="mandatory"
  >
    <template #info>
      <slot name="info" />
    </template>
    <input
      v-bind="$attrs"
      :id="id"
      :value="modelValue"
      :name="id"
      :type="type"
      :tabindex="tabindex"
      :disabled="isReadOnly || null"
      @keydown.enter.prevent="tabOnEnter && nextField($event.target)"
      @input="$emit('update:modelValue', $event.target.value)"
      @change="$emit('change', $event.target.value)"
      @blur="$emit('blur', $event.target.value)"
    />
  </form-field>
</template>

<script>
import FormField from '@/components/generic/presentational/atoms/formField/FormField.vue'
import TabOnEnter from '@/mixins/tabOnEnter.js'

export default {
  components: {
    FormField,
  },
  mixins: [TabOnEnter],
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'text',
    },
    modelValue: {
      type: [String, Number],
      required: false,
      default: '',
    },
    errorMessage: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    mandatory: {
      type: Boolean,
      default: false,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change', 'update:modelValue', 'blur'],
}
</script>
<style lang="scss" scoped>
div[disabled] {
  pointer-events: auto !important;
}
input[type='text'][disabled] {
  color: #a3b7c0;
  -webkit-text-fill-color: #a3b7c0;
}
</style>
